import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from '../hooks/useTranslation';

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();
  const { t } = useTranslation();

  return (
    <div className="language-switcher">
      <button
        className={`lang-btn ${language === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
        title={t('english')}
      >
        🇬🇧
      </button>
      <button
        className={`lang-btn ${language === 'da' ? 'active' : ''}`}
        onClick={() => changeLanguage('da')}
        title={t('danish')}
      >
        🇩🇰
      </button>
    </div>
  );
};

export default LanguageSwitcher;

